import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { AUTH_DOCUID } from 'actions/authentication'
import { loginDocuId } from '@/services/auth'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
	if (store.getters.getStatusCompanyLoad) {
		if (store.getters.isAuthenticated && store.getters.getCompanyList.length === 0) {
			next('/')
		} else {
			next()
		}
	} else
		next('/')
}

const routes = [
	{
		path: '*',
		redirect: '/'
	},
	{
		path: '/',
		name: 'Login',
		beforeEnter: function (to, from, next) {
			if (!store.getters.isAuthenticated) {
				loginDocuId()
			} else {
				next()
			}
		},
		components: {
			default: () => import('../views/ItemTable'),
			login: () => import('components/Login'),
			attach: () => import('../views/AttachCompany')
		}
	},
	{
		path: '/signup',
		name: 'Signup',
		components: {
			login: () => import('components/auth/Signup')
		},
	},
	{
		path: '/confirm-email-submission',
		name: 'Confirm email submission',
		components: {
			login: () => import('components/auth/Confirm')
		},
		props: {
			login: (route) => ({
				email: route.query.email
			})
		}
	},
	{
		path: '/confirm-email',
		name: 'Confirm email',
		components: {
			login: () => import('components/auth/ConfirmEmail')
		},
		props: {
			login: (route) => ({
				token: route.query.token
			})
		}
	},
	{
		path: '/reset-password',
		name: 'Reset password',
		components: {
			login: () => import('components/auth/ResetPassword')
		},
		props: {
			login: (route) => ({
				mode: route.query.mode,
				token: route.query.token
			})
		}
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/Dashboard'),
	},
	{
		path: '/export-history',
		name: 'Export history',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/Export')
	},
	{
		path: '/import-history',
		name: 'Import history',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/Import')
	},
	{
		path: '/item-table',
		name: 'Item Table',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemTable'),
		props: route => ({
			externalFilter: route.query.filter,
			mode: route.query.mode
		})
	},
	{
		path: '/item-edit/:id',
		name: 'Item Edit',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemEdit'),
		props: route => ({
			id: route.params.id,
			activeAttribute: route.query.activeAttribute,
			sourceItemId: route.query.sourceItemId
		})
	},
	{
		path: '/item-create',
		name: 'Item Create',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemCreate'),
		props: route => ({
			sourceItemId: route.query.sourceItemId
		})
	},
	{
		path: '/item-view/:id',
		name: 'Item View',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemView'),
		props: route => ({
			id: route.params.id
		})
	},
	{
		path: '/item-history-view/:id',
		name: 'Item View',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemView'),
		props: route => ({
			id: route.params.id,
			history: true
		})
	},
	{
		path: '/company',
		name: 'Company Profile',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyProfile'),
		props: () => ({
			action: 'edit'
		})
	},
	{
		path: '/company/users',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyUsers')
	},
	{
		path: '/company-create',
		name: 'Company Create',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyProfile'),
		props: () => ({
			action: 'create'
		})
	},
	{
		path: '/company/:id/users',
		name: 'Company Users',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyUsers'),
		props: route => ({
			id: route.params.id,
			admin: true
		})
	},
	{
		path: '/company/roles',
		name: 'Company Roles',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyRoles')
	},
	{
		path: '/company/:id/roles',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyRoles'),
		props: route => ({
			id: route.params.id,
			admin: true
		})
	},
	{
		path: '/company/groups',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyGroups')
	},
	{
		path: '/company/:id/groups',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyGroups'),props: route => ({
			id: route.params.id,
		})
	},
	{
		path: '/global-groups',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/GlobalGroups')
	},
	{
		path: '/company/notifications',
		name: 'Company Notifications',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyNotifications')
	},
	{
		path: '/company/:id/notifications',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyNotifications'),
		props: route => ({
			id: route.params.id,
			admin: true
		})
	},
	{
		path: '/company/notification-templates',
		name: 'Notification templates',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyNotificationTemplates'),
		props: route => ({
			admin: false
		})
	},
	{
		path: '/global-notification-templates',
		name: 'Global notification templates',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyNotificationTemplates'),
		props: route => ({
			admin: true
		})
	},
	{
		path: '/company/attributes',
		name: 'Company Attributes',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyAttributes')
	},
	{
		path: '/company/:id/attributes',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyAttributes'),
		props: route => ({
			id: route.params.id,
			admin: true
		})
	},
	{
		path: '/company/:id',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/CompanyProfile'),
		props: route => ({
			id: route.params.id,
			activeAttribute: route.query.activeAttribute,
			action: 'edit'
		})
	},
	{
		path: '/companies',
		name: 'Companies',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/Companies')
	},
	{
		path: '/users',
		name: 'Users',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/Users')
	},
	{
		path: '/export-configurations',
		name: 'Export configurations',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ExportСonfigurations'),
		props: () => ({
			global: false
		})
	},
	{
		path: '/global-export-configurations',
		name: 'Global export configurations',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ExportСonfigurations'),
		props: () => ({
			global: true
		})
	},
	{
		path: '/import-configurations',
		name: 'Import configurations',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ImportСonfigurations'),
		props: () => ({
			global: false
		})
	},
	{
		path: '/global-import-configurations',
		name: 'Global import configurations',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ImportСonfigurations'),
		props: () => ({
			global: true
		})
	},
	{
		path: '/global-roles',
		name: 'Roles',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/GlobalRoles')
	},
	{
		path: '/migration-resources',
		name: 'Configuration resources',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ConfigurationResources')
	},
	{
		path: '/global-migration-resources',
		name: 'Global configuration resources',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ConfigurationResources'),
		props: () => ({
			global: true
		})
	},
	{
		path: '/tag-management',
		name: 'Tag Management',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/TagManagement')
	},
	{
		path: '/global-tag-management',
		name: 'Global tag management',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/GlobalTagManagement'),
	},
	{
		path: '/translation',
		name: 'Translation',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/Translation')
	},
	{
		path: '/item-structure',
		name: 'Item Structure',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemStructure')
	},
	{
		path: '/item-validation-rules',
		name: 'Item validation rules',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/ItemValidationRules')
	},
	{
		path: '/table-columns',
		name: 'Table columns',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/TableColumns')
	},
	{
		path: '/table-filter',
		name: 'Table filter',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/TableFilter')
	},
	{
		path: '/attach',
		name: 'Attach company',
		beforeEnter: ifAuthenticated,
		component: () => import('../views/AttachCompany')
	},

	{
		path: '/oauth/docuid/callback',
		beforeEnter: (to, from, next) => {
			var ClientOAuth2 = require('client-oauth2')
			var clientAuth = new ClientOAuth2({
				clientId: process.env.VUE_APP_CLIENT_ID,
				authorizationUri: process.env.VUE_APP_NODE_AUTHORIZATION_URI,
				redirectUri: process.env.VUE_APP_NODE_AUTHORIZATION_REDIRECT_URI
			})

			store.dispatch('SET_OAUTH_STATUS', true)

			clientAuth.token.getToken(to.fullPath, {redirectUri: '/oauth/docuid/callback'})
				.then(function (user) {
					let token = 'Bearer ' + user.accessToken;
					store.dispatch('SET_TOKEN', token).then(() => {
						store.dispatch(AUTH_DOCUID).then(() => {
							if (user.data.ref) {
								next(user.data.ref)
							} else {
								next('/dashboard')
							}
						})
					}).then(() => {
						// next('/')
					})
				})

		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
